import { Injectable } from '@angular/core';
import { Lab } from '../models/lab.model';
import { Lookup } from '../models/lookup.model';
import { ReportTemplate } from '../models/reportTemplate.model';
import { Template } from '../models/template.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GridService } from '../shared/grid/grid.service';
import { ReportTemplateService } from './reportTemplate.service';

@Injectable({
  providedIn: 'root'
})
export class LabService extends GridService<Lab> {
  constructor(http: HttpClient, private reportTemplateService: ReportTemplateService) {
    super('Lab', http);
  }

  getCocTemplate(labId: string): Observable<ReportTemplate> {
    return this.http.get<Template>(this.getApiUrl(`labs/${labId}/coc-template`)).pipe(
      map(dto => this.reportTemplateService.convertToReportTemplate(dto))
    );
  }

  getCocTemplateOptions(organizationLevelId: string): Observable<Lookup[]> {
    return this.http.get<Lookup[]>(this.getApiUrl('labs/coc-templates'), { params: { organizationLevelId } });
  }
}
